import { IMockReqAndRes } from "src/app/libs/data-access/mocks/mocks.interface";

export namespace MockedHotelsService {
  export const getHotelsMock: IMockReqAndRes = {
    request: {
      hotelsCriteria: {
        criteria: {
          checkIn: "2024-01-27",
          checkOut: "2024-01-30",
          city: "London",
          language: "ENG",
          occupancies: [
            {
              adults: 2,
              children: 0,
              rooms: 2
            }
          ]
        },
        metadata: {
          page: 1,
          rpp: 5
        }
      },
      filters: {},
      sort: {
        price: "asc"
      },
      hotelId: 126177,
      packageMetadata: {
        isPackage: true,
        persons: {
          adult: 2,
          children: 0,
          total: 2,
          totalRooms: 2
        }
      }
    },
    response: {
      hotels: [
        {
          id: 126177,
          code: 98193,
          name: "Convent de la Missio",
          starsRating: {
            code: "5EST",
            description: "5 STARS"
          },
          destinationName: "Majorca",
          rooms: [
            {
              apartmentDescription: "DOUBLE OR TWIN WITH BALCONY",
              rates: [
                {
                  price: 0,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.BL|PQ-BARHSI RO|RO||2~2~0||P@06~~228144~305297171~N~~~NOR~A8D0B29A14E9418170620314986400AAUK00000050000000010228144",
                  rateType: "BOOKABLE",
                  allotment: 49,
                  boardCode: "RO",
                  boardName: "ROOM ONLY",
                  cancellationPolicy: {
                    amount: "108.64",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 7.86,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.BL|BARHSI RO|RO||2~2~0||N@06~~200186~147839095~N~~~NOR~A8D0B29A14E9418170620314986400AAUK0000005000000001020c154",
                  rateType: "BOOKABLE",
                  allotment: 50,
                  boardCode: "RO",
                  boardName: "ROOM ONLY",
                  cancellationPolicy: {
                    amount: "113.90",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 28.79,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.BL|PQ-BARHSI BB|BB||2~2~0||P@06~~26217d~1292040403~N~~~NOR~A8D0B29A14E9418170620314986400AAUK0000005000000001026217d",
                  rateType: "BOOKABLE",
                  allotment: 50,
                  boardCode: "BB",
                  boardName: "BED AND BREAKFAST",
                  cancellationPolicy: {
                    amount: "127.92",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 54.95,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.BL|PQ-BARHSI HB|HB||2~2~0||P@06~~21e1b2~-1342963021~N~~~NOR~A8D0B29A14E9418170620314986400AAUK0000005000000001021e1b2",
                  rateType: "BOOKABLE",
                  allotment: 50,
                  boardCode: "HB",
                  boardName: "HALF BOARD",
                  cancellationPolicy: {
                    amount: "145.44",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 91.58,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.BL|BARHSI BB|BB||2~2~0||N@06~~200246~-664602403~N~~~NOR~A8D0B29A14E9418170620314986400AAUK000000500000000102381fb",
                  rateType: "BOOKABLE",
                  allotment: 100,
                  boardCode: "BB",
                  boardName: "BED AND BREAKFAST",
                  cancellationPolicy: {
                    amount: "169.98",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 112.51,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.BL|BARHSI HB|HB||2~2~0||N@06~~200276~1577418270~N~~~NOR~A8D0B29A14E9418170620314986400AAUK0000005000000001022a225",
                  rateType: "BOOKABLE",
                  allotment: 100,
                  boardCode: "HB",
                  boardName: "HALF BOARD",
                  cancellationPolicy: {
                    amount: "184.00",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                }
              ],
              roomCode: "DBT.BL",
              maxPax: 2,
              type: {
                code: "DBT",
                description: {
                  content: "Double or Twin"
                }
              },
              roomFacilities: [
                {
                  facilityCode: 220,
                  facilityGroupCode: 60,
                  description: {
                    content: "Living room"
                  },
                  indLogic: false,
                  number: 0,
                  voucher: false
                }
              ]
            },
            {
              apartmentDescription: "DOUBLE OR TWIN SUPERIOR",
              rates: [
                {
                  price: 23.56,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.SU|PQ-BARHSI RO|RO||2~2~0||P@06~~234173~-1554079349~N~~~NOR~A8D0B29A14E9418170620314986400AAUK00000050000000010234173",
                  rateType: "BOOKABLE",
                  allotment: 10,
                  boardCode: "RO",
                  boardName: "ROOM ONLY",
                  cancellationPolicy: {
                    amount: "124.42",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 34.02,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.SU|BARHSI RO|RO||2~2~0||N@06~~2001c2~-1526473231~N~~~NOR~A8D0B29A14E9418170620314986400AAUK0000005000000001022c188",
                  rateType: "BOOKABLE",
                  allotment: 10,
                  boardCode: "RO",
                  boardName: "ROOM ONLY",
                  cancellationPolicy: {
                    amount: "131.42",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 52.32,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.SU|PQ-BARHSI BB|BB||2~2~0||P@06~~2041ad~10836011~N~~~NOR~A8D0B29A14E9418170620314986400AAUK000000500000000102041ad",
                  rateType: "BOOKABLE",
                  allotment: 10,
                  boardCode: "BB",
                  boardName: "BED AND BREAKFAST",
                  cancellationPolicy: {
                    amount: "143.68",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 78.5,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.SU|PQ-BARHSI HB|HB||2~2~0||P@06~~2281e1~-552741749~N~~~NOR~A8D0B29A14E9418170620314986400AAUK000000500000000102281e1",
                  rateType: "BOOKABLE",
                  allotment: 10,
                  boardCode: "HB",
                  boardName: "HALF BOARD",
                  cancellationPolicy: {
                    amount: "161.22",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 125.59,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.SU|BARHSI BB|BB||2~2~0||N@06~~200294~-615638181~N~~~NOR~A8D0B29A14E9418170620314986400AAUK0000005000000001023a23f",
                  rateType: "BOOKABLE",
                  allotment: 10,
                  boardCode: "BB",
                  boardName: "BED AND BREAKFAST",
                  cancellationPolicy: {
                    amount: "192.76",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                },
                {
                  price: 136.05,
                  paymentType: "AT_WEB",
                  rateKey: "20240127|20240130|W|1|126177|DBT.SU|BARHSI HB|HB||2~2~0||N@06~~2002ac~-103690929~N~~~NOR~A8D0B29A14E9418170620314986400AAUK00000050000000010232254",
                  rateType: "BOOKABLE",
                  allotment: 10,
                  boardCode: "HB",
                  boardName: "HALF BOARD",
                  cancellationPolicy: {
                    amount: "199.76",
                    from: "2024-01-25T23:59:00+01:00"
                  },
                  taxes: {
                    amount: "9.90",
                    included: false
                  }
                }
              ],
              roomCode: "DBT.SU",
              maxPax: 2,
              type: {
                code: "DBT",
                description: {
                  content: "Double or Twin"
                }
              }
            }
          ],
          rateRange: {
            minRate: "324.40",
            maxRate: "324.40"
          },
          currency: "EUR",
          images: [
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_146.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "TPL",
              roomCode: "TPL.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_147.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "TPL",
              roomCode: "TPL.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_120.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_148.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "TPL",
              roomCode: "TPL.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_206.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.SU"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_207.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.SU"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_145.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "TPL",
              roomCode: "TPL.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_f_004.jpg",
              imgFacilityType: "Sports and Entertainment",
              code: "DEP"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_f_005.jpg",
              imgFacilityType: "Sports and Entertainment",
              code: "DEP"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_204.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.SU"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_202.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.SU"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_l_003.jpg",
              imgFacilityType: "Lobby",
              code: "COM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_p_010.jpg",
              imgFacilityType: "Pool",
              code: "PIS"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_207.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.SU-VM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_001.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_002.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_l_009.jpg",
              imgFacilityType: "Lobby",
              code: "COM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_003.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_l_008.jpg",
              imgFacilityType: "Lobby",
              code: "COM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_004.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_005.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_118.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_176.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_006.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_l_005.jpg",
              imgFacilityType: "Lobby",
              code: "COM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_119.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_175.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_007.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_l_004.jpg",
              imgFacilityType: "Lobby",
              code: "COM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_123.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_174.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_008.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_l_007.jpg",
              imgFacilityType: "Lobby",
              code: "COM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_173.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_009.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_l_006.jpg",
              imgFacilityType: "Lobby",
              code: "COM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_a_040.jpg",
              imgFacilityType: "General view",
              code: "GEN"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_185.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU-VM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_a_041.jpg",
              imgFacilityType: "General view",
              code: "GEN"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_131.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_a_042.jpg",
              imgFacilityType: "General view",
              code: "GEN"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_132.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_182.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU-VM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_181.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU-VM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_184.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU-VM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_183.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU-VM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_179.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_178.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_177.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_p_009.jpg",
              imgFacilityType: "Pool",
              code: "PIS"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_180.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.SU-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_a_038.jpg",
              imgFacilityType: "General view",
              code: "GEN"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_a_039.jpg",
              imgFacilityType: "General view",
              code: "GEN"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_133.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_045.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_k_002.jpg",
              imgFacilityType: "Conferences",
              code: "CON"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_k_001.jpg",
              imgFacilityType: "Conferences",
              code: "CON"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_010.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_219.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.VP"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_217.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.VP"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ba_011.jpg",
              imgFacilityType: "Bar",
              code: "BAR"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_218.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.VP"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_203.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.SU-VM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_201.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.SU-VM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_063.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "SGL",
              roomCode: "SGL.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_200.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.SU-VM"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_r_010.jpg",
              imgFacilityType: "Restaurant",
              code: "RES"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_r_011.jpg",
              imgFacilityType: "Restaurant",
              code: "RES"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_r_012.jpg",
              imgFacilityType: "Restaurant",
              code: "RES"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_212.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.BL-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_210.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.BL-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_191.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.BL"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_192.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.BL"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_211.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.BL"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_213.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DUS",
              roomCode: "DUS.BL"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_r_009.jpg",
              imgFacilityType: "Restaurant",
              code: "RES"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_r_007.jpg",
              imgFacilityType: "Restaurant",
              code: "RES"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_r_008.jpg",
              imgFacilityType: "Restaurant",
              code: "RES"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_190.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VM-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_t_001.jpg",
              imgFacilityType: "Terrace",
              code: "TER"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_t_002.jpg",
              imgFacilityType: "Terrace",
              code: "TER"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_187.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VM-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_220.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VP-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_221.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VP-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_189.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VM-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_222.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VP-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_188.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VM-1"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_w_008.jpg",
              imgFacilityType: "Room",
              code: "HAB"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_w_005.jpg",
              imgFacilityType: "Room",
              code: "HAB"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_w_004.jpg",
              imgFacilityType: "Room",
              code: "HAB"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_w_007.jpg",
              imgFacilityType: "Room",
              code: "HAB"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_w_006.jpg",
              imgFacilityType: "Room",
              code: "HAB"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_004.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "SGL",
              roomCode: "SGL.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_003.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "SGL",
              roomCode: "SGL.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_002.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "SGL",
              roomCode: "SGL.ST"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_w_001.jpg",
              imgFacilityType: "Room",
              code: "HAB"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_w_003.jpg",
              imgFacilityType: "Room",
              code: "HAB"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_w_002.jpg",
              imgFacilityType: "Room",
              code: "HAB"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_216.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VP"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_215.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VP"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_ro_214.jpg",
              imgFacilityType: "Room",
              code: "HAB",
              roomType: "DBT",
              roomCode: "DBT.VP"
            },
            {
              url: "http://photos.hotelbeds.com/giata/12/126177/126177a_hb_p_011.jpg",
              imgFacilityType: "Pool",
              code: "PIS"
            }
          ],
          description: "The old Convent de la Missio, built during the seventeenth century for the purpose of educating missionaries, stands surrounded by small streets and courtyards with gardens in Palma's old town centre.\n\nToday, having undergone careful renovation, it has become an exclusive hotel where elegance blends with serenity, resulting in a unique space, full of beauty and immersed in art, distinguished for its tranquility and harmony.",
          address: {
            country: "Spain",
            street: "Missio",
            buildingNumber: "7",
            city: "PALMA DE MALLORCA",
            postalCode: "07003"
          },
          contactDetails: {
            email: "hotel@conventdelamissio.com",
            phones: [
              {
                phoneNumber: "+34971227347",
                phoneType: "PHONEBOOKING"
              },
              {
                phoneNumber: "+34971227347",
                phoneType: "PHONEHOTEL"
              }
            ]
          },
          propertyType: {
            code: "H",
            description: "Hotel"
          },
          lastUpdate: "2023-07-25",
          facilities: [
            {
              facilityCode: 70,
              facilityGroupCode: 10,
              description: {
                content: "Total number of rooms"
              },
              order: 1,
              indYesOrNo: true,
              number: 27,
              voucher: false
            },
            {
              facilityCode: 10,
              facilityGroupCode: 20,
              description: {
                content: "hotel"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 10,
              facilityGroupCode: 30,
              description: {
                content: "American Express"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 50,
              facilityGroupCode: 30,
              description: {
                content: "MasterCard"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 60,
              facilityGroupCode: 30,
              description: {
                content: "Visa"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 80,
              facilityGroupCode: 40,
              description: {
                content: "Airport"
              },
              order: 1,
              distance: 7400,
              voucher: false
            },
            {
              facilityCode: 70,
              facilityGroupCode: 40,
              description: {
                content: "Harbour"
              },
              order: 1,
              distance: 400,
              voucher: false
            },
            {
              facilityCode: 298,
              facilityGroupCode: 60,
              description: {
                content: "Number of bedrooms"
              },
              order: 1,
              indLogic: false,
              number: 1,
              voucher: false
            },
            {
              facilityCode: 260,
              facilityGroupCode: 60,
              description: {
                content: "Disability-friendly bathroom"
              },
              order: 1,
              indLogic: false,
              voucher: false
            },
            {
              facilityCode: 40,
              facilityGroupCode: 60,
              description: {
                content: "Hairdryer"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 276,
              facilityGroupCode: 60,
              description: {
                content: "Toiletries"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 280,
              facilityGroupCode: 60,
              description: {
                content: "Bathrobes"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 261,
              facilityGroupCode: 60,
              description: {
                content: "Wi-fi"
              },
              order: 1,
              indFee: false,
              indYesOrNo: true,
              voucher: false
            },
            {
              facilityCode: 100,
              facilityGroupCode: 60,
              description: {
                content: "Internet access"
              },
              order: 1,
              indLogic: false,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 50,
              facilityGroupCode: 60,
              description: {
                content: "Direct dial telephone"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 55,
              facilityGroupCode: 60,
              description: {
                content: "TV"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 120,
              facilityGroupCode: 60,
              description: {
                content: "Minibar"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 170,
              facilityGroupCode: 60,
              description: {
                content: "Centrally regulated air conditioning"
              },
              order: 1,
              indLogic: true,
              voucher: false
            },
            {
              facilityCode: 190,
              facilityGroupCode: 60,
              description: {
                content: "Central heating"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 200,
              facilityGroupCode: 60,
              description: {
                content: "Safe"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 250,
              facilityGroupCode: 60,
              description: {
                content: "Wheelchair-accessible"
              },
              order: 1,
              indYesOrNo: true,
              voucher: false
            },
            {
              facilityCode: 287,
              facilityGroupCode: 60,
              description: {
                content: "Smoking rooms"
              },
              order: 1,
              indYesOrNo: false,
              voucher: false
            },
            {
              facilityCode: 275,
              facilityGroupCode: 60,
              description: {
                content: "Extra beds on demand"
              },
              order: 1,
              indLogic: false,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 264,
              facilityGroupCode: 60,
              description: {
                content: "Cot on demand"
              },
              order: 1,
              indLogic: false,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 295,
              facilityGroupCode: 70,
              description: {
                content: "Wheelchair-accessible"
              },
              order: 1,
              indYesOrNo: false,
              voucher: false
            },
            {
              facilityCode: 320,
              facilityGroupCode: 70,
              description: {
                content: "Car park"
              },
              order: 1,
              indFee: false,
              indYesOrNo: false,
              voucher: true
            },
            {
              facilityCode: 30,
              facilityGroupCode: 70,
              description: {
                content: "24-hour reception"
              },
              order: 1,
              indYesOrNo: true,
              voucher: false
            },
            {
              facilityCode: 260,
              facilityGroupCode: 70,
              description: {
                content: "Check-in hour"
              },
              order: 1,
              timeFrom: "15:00:00",
              timeTo: "12:00:00",
              voucher: true
            },
            {
              facilityCode: 390,
              facilityGroupCode: 70,
              description: {
                content: "Check-out hour"
              },
              order: 1,
              timeFrom: "12:00:00",
              timeTo: "12:00:00",
              voucher: false
            },
            {
              facilityCode: 240,
              facilityGroupCode: 70,
              description: {
                content: "Mobile phone coverage"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 550,
              facilityGroupCode: 70,
              description: {
                content: "Wi-fi"
              },
              order: 1,
              indFee: false,
              indYesOrNo: true,
              voucher: false
            },
            {
              facilityCode: 556,
              facilityGroupCode: 70,
              description: {
                content: "Local and international calls"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 490,
              facilityGroupCode: 70,
              description: {
                content: "Car hire"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 495,
              facilityGroupCode: 70,
              description: {
                content: "Transfer service"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 562,
              facilityGroupCode: 70,
              description: {
                content: "Airport Shuttle"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 270,
              facilityGroupCode: 70,
              description: {
                content: "Room service"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 280,
              facilityGroupCode: 70,
              description: {
                content: "Laundry service"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 310,
              facilityGroupCode: 70,
              description: {
                content: "Bicycle hire service"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 485,
              facilityGroupCode: 70,
              description: {
                content: "Babysitting service"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 505,
              facilityGroupCode: 70,
              description: {
                content: "Multilingual staff"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 10,
              facilityGroupCode: 70,
              description: {
                content: "Air conditioning in public areas"
              },
              order: 1,
              indLogic: true,
              voucher: false
            },
            {
              facilityCode: 11,
              facilityGroupCode: 70,
              description: {
                content: "Fireplace"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 40,
              facilityGroupCode: 70,
              description: {
                content: "Hotel safe"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 70,
              facilityGroupCode: 70,
              description: {
                content: "Lift access"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 125,
              facilityGroupCode: 70,
              description: {
                content: "Garden"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 135,
              facilityGroupCode: 70,
              description: {
                content: "Terrace"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 585,
              facilityGroupCode: 70,
              description: {
                content: "Concierge"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 430,
              facilityGroupCode: 70,
              description: {
                content: "Sun terrace"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 470,
              facilityGroupCode: 70,
              description: {
                content: "Gym"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 515,
              facilityGroupCode: 70,
              description: {
                content: "Newspapers"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 559,
              facilityGroupCode: 70,
              description: {
                content: "Luggage room"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 568,
              facilityGroupCode: 70,
              description: {
                content: "Clothes dryer"
              },
              order: 1,
              indLogic: true,
              voucher: false
            },
            {
              facilityCode: 130,
              facilityGroupCode: 71,
              description: {
                content: "Bar"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 200,
              facilityGroupCode: 71,
              description: {
                content: "Restaurant"
              },
              order: 1,
              indLogic: true,
              voucher: false
            },
            {
              facilityCode: 220,
              facilityGroupCode: 71,
              description: {
                content: "Non-smoking area"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 225,
              facilityGroupCode: 71,
              description: {
                content: "Smoking area"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 230,
              facilityGroupCode: 71,
              description: {
                content: "Highchairs"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 170,
              facilityGroupCode: 72,
              description: {
                content: "Conference room"
              },
              order: 1,
              indLogic: true,
              voucher: false
            },
            {
              facilityCode: 575,
              facilityGroupCode: 72,
              description: {
                content: "Meeting room"
              },
              order: 1,
              indLogic: true,
              voucher: false
            },
            {
              facilityCode: 363,
              facilityGroupCode: 73,
              description: {
                content: "Outdoor freshwater pool"
              },
              order: 1,
              indFee: false,
              number: 1,
              voucher: false
            },
            {
              facilityCode: 420,
              facilityGroupCode: 74,
              description: {
                content: "Sauna"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 410,
              facilityGroupCode: 74,
              description: {
                content: "Hot tub"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 40,
              facilityGroupCode: 80,
              description: {
                content: "Breakfast"
              },
              order: 1,
              indLogic: true,
              voucher: false
            },
            {
              facilityCode: 203,
              facilityGroupCode: 85,
              description: {
                content: "Only Adults"
              },
              order: 1,
              indLogic: true,
              ageFrom: 16,
              voucher: true
            },
            {
              facilityCode: 561,
              facilityGroupCode: 85,
              description: {
                content: "Deposit on arrival"
              },
              order: 1,
              indLogic: true,
              voucher: true
            },
            {
              facilityCode: 557,
              facilityGroupCode: 85,
              description: {
                content: "Identification card at arrival"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: true
            },
            {
              facilityCode: 562,
              facilityGroupCode: 85,
              description: {
                content: "Non-smoking establishment"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            },
            {
              facilityCode: 295,
              facilityGroupCode: 90,
              description: {
                content: "Fitness"
              },
              order: 1,
              indLogic: true,
              indFee: false,
              voucher: false
            }
          ],
          boards: [
            {
              code: "BB",
              description: {
                content: "BED AND BREAKFAST"
              }
            },
            {
              code: "RO",
              description: {
                content: "ROOM ONLY"
              }
            }
          ],
          segments: [
            {
              code: 34,
              description: {
                content: "Business hotels "
              }
            }
          ],
          coordinates: {
            longitude: 2.65149,
            latitude: 39.57335
          },
          interestPoints: [
            {
              facilityCode: 30,
              facilityGroupCode: 100,
              order: 1,
              poiName: "El Corte Ingles Shopping Centre",
              distance: "400"
            },
            {
              facilityCode: 20,
              facilityGroupCode: 100,
              order: 1,
              poiName: "San Juan Gastronomic Market",
              distance: "1200"
            },
            {
              facilityCode: 10,
              facilityGroupCode: 100,
              order: 1,
              poiName: "Plaza Mayor",
              distance: "300"
            }
          ]
        }
      ],
      metadata: {
        page: 1,
        rpp: 5,
        currentPageRecords: 5,
        totalPages: 1,
        totalRecords: 1,
        totalRecordsLeft: 0
      }
    },
  };
}
